// extracted by mini-css-extract-plugin
module.exports = {"image":"SearchNoResult_image__vh2y0","wrapper":"SearchNoResult_wrapper__gtOHI"};